import { useEffect, useState } from "react";
import { Button } from "antd";
import {
  CheckCircleFilled,
  MenuOutlined,
  DownCircleFilled,
  RightCircleFilled,
} from "@ant-design/icons";
import { ReactComponent as HelpIcon } from "../../assets/images/Help.svg";
import moment from "moment-timezone";
import "./NavBar.scss";

function NavBar(props) {
  const [date, setDate] = useState(new Date());
  // eslint-disable-next-line no-unused-vars
  const [timezone, setTimezone] = useState(moment.tz.guess());
  const { collapsed, toggleCollapse } = props;

  useEffect(() => {
    const timerID = setInterval(() => setDate(new Date()), 1000);
    return () => clearInterval(timerID);
  }, []);

  return (
    <div className="navbar">
      <div style={{ padding: "0 15px" }}>
        <MenuOutlined style={{ color: "#80c342" }} />
      </div>
      <span>
        <CheckCircleFilled
          onClick={() => window.close()}
          style={{ color: "#80c342" }}
        />
      </span>
      <div className="page-title">
        <span className="header-title">Management</span>
        <span className="farm-title">
          {/* - {timezone} {date.toLocaleTimeString()} */}
        </span>
        <span className="detail-title"></span>
      </div>
      <div style={{ marginLeft: "auto" }}>
        <Button
          type="text"
          style={{ color: "#fff" }}
          onClick={toggleCollapse}
          icon={
            !collapsed ? (
              <DownCircleFilled style={{ color: "#80c342" }} />
            ) : (
              <RightCircleFilled style={{ color: "#80c342" }} />
            )
          }
        >
          TOOLBOX
        </Button>
        <Button type="text" icon={<HelpIcon className="help-icon" />} />
      </div>
    </div>
  );
}

export default NavBar;
